// Translations for Fasade Akershus — Norwegian (default) + English
export const translations = {
  no: {
    nav: {
      services: "Tjenester",
      about: "Om meg",
      gallery: "Galleri",
      testimonials: "Anmeldelser",
      contact: "Kontakt",
      cta: "Be om tilbud",
    },
    hero: {
      eyebrow: "Fasademaling i Akershus & Oslo",
      title_a: "Rene linjer.",
      title_b: "Pålitelig håndverk.",
      title_c: "Et hjem du er stolt av.",
      desc:
        "Profesjonell fasademaling og vedlikehold av hus, terrasse og uteområde — utført med omhu, nøyaktighet og full ryddighet etter endt arbeid.",
      cta_primary: "Be om uforpliktende tilbud",
      cta_secondary: "Se tjenester",
      stat_1: "Akershus & Oslo",
      stat_1_label: "Område",
      stat_2: "1 til 1",
      stat_2_label: "Personlig service",
      stat_3: "Kvinne-drevet",
      stat_3_label: "Trygt valg",
    },
    services: {
      eyebrow: "Tjenester",
      title: "Det jeg gjør, gjør jeg ordentlig.",
      desc:
        "Fasademaling er hovedfaget mitt. Ved siden av tar jeg på meg lettere vedlikeholdsoppgaver rundt huset — uten inngrep i konstruksjonen.",
      items: [
        {
          title: "Fasademaling",
          desc:
            "Vasking, sliping, grunning og to strøk maling. Trefasade, panel og kledning. Riktig forarbeid er halve jobben.",
        },
        {
          title: "Småreparasjoner",
          desc:
            "Bytte av enkeltbord, tetting av sprekker, justering av lister og overflater — uten inngrep i bærende konstruksjon.",
        },
        {
          title: "Vedlikehold uteområde",
          desc:
            "Rensing av tak, takrenner, fasade og uteplass. Småjobber som holder huset friskt år etter år.",
        },
        {
          title: "Terrasser & hager",
          desc:
            "Olje og beising av terrasse, plenklipp, beskjæring og enkel skjøtsel av hage rundt eiendommen.",
        },
      ],
    },
    about: {
      eyebrow: "Om meg",
      title: "Én håndverker. Ett ansvar. Hele jobben — fra start til slutt.",
      p1:
        "Jeg er kvinnen bak Fasade Akershus. Jeg jobber alene, og det er bevisst: du får én kontaktperson, ett tilbud, ett menneske som tar ansvaret fra første befaring til siste penselstrøk.",
      p2:
        "Mange kunder — særlig kvinner som bor alene — sier de føler seg tryggere når en kvinne kommer hjem til dem. Det gleder meg, og det er en del av hvorfor jeg gjør dette. Men jobben min skal stå på egne ben: ren, presis og ferdig i tide.",
      signature: "— Fasade Akershus",
    },
    gallery: {
      eyebrow: "Referanser",
      title: "Litt av det jeg har gjort.",
      desc: "Bilder oppdateres jevnlig. Kontakt meg gjerne for flere referanser i ditt område.",
    },
    testimonials: {
      eyebrow: "Anmeldelser",
      title: "Det kundene sier.",
      items: [
        {
          quote:
            "Ryddig, presis og hyggelig fra første dag. Fasaden ser ut som ny, og prisen var som avtalt.",
          name: "Ingrid H.",
          place: "Bærum",
        },
        {
          quote:
            "Jeg bor alene og var litt nølende først, men det var trygt og profesjonelt hele veien. Anbefales.",
          name: "Marit S.",
          place: "Oslo",
        },
        {
          quote:
            "Hun ryddet etter seg som om hun aldri hadde vært her. Veggene derimot — strålende.",
          name: "Per Olav K.",
          place: "Asker",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Be om uforpliktende tilbud.",
      desc:
        "Fyll ut skjemaet — det er den raskeste måten å få et nøyaktig tilbud på. Jeg svarer personlig innen 24 timer, ofte mye raskere.",
      form_highlight: "Anbefalt",
      form_subtitle: "Skjemaet gir meg alt jeg trenger for å svare presist — uten flere runder med oppfølging.",
      direct_label: "Foretrekker du å snakke direkte?",
      form: {
        name: "Navn",
        phone: "Telefon",
        email: "E-post (valgfritt)",
        service: "Tjeneste",
        service_options: [
          "Fasademaling",
          "Småreparasjoner",
          "Vedlikehold uteområde",
          "Terrasser & hager",
          "Annet",
        ],
        message: "Beskriv jobben",
        submit: "Send forespørsel",
        submitting: "Sender …",
        success: "Takk! Jeg tar kontakt innen 24 timer.",
        error: "Noe gikk galt. Prøv igjen, eller ring 46 393 022.",
      },
      info: {
        phone_label: "Telefon",
        email_label: "E-post",
        area_label: "Område",
        area: "Akershus & Oslo",
      },
    },
    footer: {
      tagline: "Fasademaling & vedlikehold — Akershus & Oslo",
      rights: "Alle rettigheter forbeholdt.",
    },
    badge: {
      top: "KVINNE FOR KVINNE",
      bottom: "TRYGT VALG",
    },
    sticky: {
      call: "Ring",
      quote: "Tilbud",
    },
  },
  en: {
    nav: {
      services: "Services",
      about: "About",
      gallery: "Gallery",
      testimonials: "Reviews",
      contact: "Contact",
      cta: "Request a quote",
    },
    hero: {
      eyebrow: "Facade painting in Akershus & Oslo",
      title_a: "Clean lines.",
      title_b: "Reliable craftsmanship.",
      title_c: "A home you're proud of.",
      desc:
        "Professional facade painting and house maintenance — done with care, precision and a fully tidy site when I leave.",
      cta_primary: "Request a free quote",
      cta_secondary: "See services",
      stat_1: "Akershus & Oslo",
      stat_1_label: "Area",
      stat_2: "1 on 1",
      stat_2_label: "Personal service",
      stat_3: "Woman-run",
      stat_3_label: "A safe choice",
    },
    services: {
      eyebrow: "Services",
      title: "What I do, I do properly.",
      desc:
        "Facade painting is my main craft. Alongside it I take on lighter maintenance work around the house — without touching the structure.",
      items: [
        {
          title: "Facade painting",
          desc:
            "Washing, sanding, priming and two coats. Wood facades, panels and cladding. Good prep is half the job.",
        },
        {
          title: "Minor repairs",
          desc:
            "Replacing single boards, sealing cracks, adjusting trims and surfaces — no structural work.",
        },
        {
          title: "Outdoor maintenance",
          desc:
            "Cleaning of roof, gutters, facade and outdoor areas. Small jobs that keep your house healthy year after year.",
        },
        {
          title: "Terraces & gardens",
          desc:
            "Oiling and staining of decks, lawn care, light pruning and simple garden upkeep around the property.",
        },
      ],
    },
    about: {
      eyebrow: "About me",
      title: "One craftsman. One responsibility. The whole job — start to finish.",
      p1:
        "I'm the woman behind Fasade Akershus. I work alone, on purpose: you get one contact, one quote, one person who takes responsibility from the first visit to the last brushstroke.",
      p2:
        "Many clients — especially women living alone — tell me they feel safer when a woman comes to their home. That makes me happy, and it's part of why I do this. But the work itself stands on its own: clean, precise and finished on time.",
      signature: "— Fasade Akershus",
    },
    gallery: {
      eyebrow: "References",
      title: "Some of my recent work.",
      desc: "Photos updated regularly. Contact me for more references in your area.",
    },
    testimonials: {
      eyebrow: "Reviews",
      title: "What clients say.",
      items: [
        {
          quote:
            "Tidy, precise and friendly from day one. The facade looks brand new and the price was exactly as agreed.",
          name: "Ingrid H.",
          place: "Bærum",
        },
        {
          quote:
            "I live alone and was a bit hesitant at first — but it was safe and professional all the way. Highly recommended.",
          name: "Marit S.",
          place: "Oslo",
        },
        {
          quote:
            "She cleaned up as if she'd never been here. The walls though — gorgeous.",
          name: "Per Olav K.",
          place: "Asker",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Request a free, no-obligation quote.",
      desc:
        "Fill in the form — it's the fastest way to get a precise quote. I reply personally within 24 hours, often much sooner.",
      form_highlight: "Recommended",
      form_subtitle: "The form gives me everything I need to answer precisely — no follow-up rounds needed.",
      direct_label: "Prefer to talk directly?",
      form: {
        name: "Name",
        phone: "Phone",
        email: "Email (optional)",
        service: "Service",
        service_options: [
          "Facade painting",
          "Minor repairs",
          "Outdoor maintenance",
          "Terraces & gardens",
          "Other",
        ],
        message: "Describe the job",
        submit: "Send request",
        submitting: "Sending …",
        success: "Thank you! I'll be in touch within 24 hours.",
        error: "Something went wrong. Please try again or call 46 393 022.",
      },
      info: {
        phone_label: "Phone",
        email_label: "Email",
        area_label: "Area",
        area: "Akershus & Oslo",
      },
    },
    footer: {
      tagline: "Facade painting & maintenance — Akershus & Oslo",
      rights: "All rights reserved.",
    },
    badge: {
      top: "WOMAN FOR WOMAN",
      bottom: "A SAFE CHOICE",
    },
    sticky: {
      call: "Call",
      quote: "Quote",
    },
  },
};
